export default __webpack_public_path__ + "static/media/2020_CARIN_Code_of_Conduct_May2020.1b61a1f1.pdf";